export default "__VITE_ASSET__a66492cf__"